import { z } from "zod";
import { createZodDto } from "nestjs-zod/dto";
import { resumeDataSchema } from "@reactive-resume/schema";

export const optimizedDataSchema = z.object({
  initialResume: resumeDataSchema,
  resume: resumeDataSchema,
  initialAnalysis: z.any(),
  analysis: z.any(),
});

export const optimizedSchema = z.object({
  type: z.literal("optimized"),
  data: optimizedDataSchema,
});

export class OptimizedDataDto extends createZodDto(optimizedDataSchema) {}

export class OptimizedDto extends createZodDto(optimizedSchema) {}

export type ResumeData = z.infer<typeof resumeDataSchema>;
